import HttpRequest from '@/libs/axios1'
const baseUrl = process.env.NODE_ENV === 'development' ? "http://localhost:9080/v1/api" : "https://localhost:9081/v1/api"

const axios1 = new HttpRequest(baseUrl)
export default axios1
